export const allCountries = [
       {
      "@id": "/countries/ABW",
      "@type": "Country",
      "iso3": "ABW",
      "iso2": "AW",
      "name": "Aruba",
      "capital": "Oranjestad",
      "currency": "AWG",
      "phone": "297",
      "sanctioned": false
    },
    {
      "@id": "/countries/AFG",
      "@type": "Country",
      "iso3": "AFG",
      "iso2": "AF",
      "name": "Afghanistan",
      "capital": "Kabul",
      "currency": "AFN",
      "phone": "93",
      "sanctioned": false
    },
    {
      "@id": "/countries/AGO",
      "@type": "Country",
      "iso3": "AGO",
      "iso2": "AO",
      "name": "Angola",
      "capital": "Luanda",
      "currency": "AOA",
      "phone": "244",
      "sanctioned": false
    },
    {
      "@id": "/countries/AIA",
      "@type": "Country",
      "iso3": "AIA",
      "iso2": "AI",
      "name": "Anguilla",
      "capital": "The Valley",
      "currency": "XCD",
      "phone": "+1-264",
      "sanctioned": false
    },
    {
      "@id": "/countries/ALA",
      "@type": "Country",
      "iso3": "ALA",
      "iso2": "AX",
      "name": "Aland Islands",
      "capital": "Mariehamn",
      "currency": "EUR",
      "phone": "+358-18",
      "sanctioned": false
    },
    {
      "@id": "/countries/ALB",
      "@type": "Country",
      "iso3": "ALB",
      "iso2": "AL",
      "name": "Albania",
      "capital": "Tirana",
      "currency": "ALL",
      "phone": "355",
      "sanctioned": false
    },
    {
      "@id": "/countries/AND",
      "@type": "Country",
      "iso3": "AND",
      "iso2": "AD",
      "name": "Andorra",
      "capital": "Andorra la Vella",
      "currency": "EUR",
      "phone": "376",
      "sanctioned": false
    },
    {
      "@id": "/countries/ARE",
      "@type": "Country",
      "iso3": "ARE",
      "iso2": "AE",
      "name": "United Arab Emirates",
      "capital": "Abu Dhabi",
      "currency": "AED",
      "phone": "971",
      "sanctioned": false
    },
    {
      "@id": "/countries/ARG",
      "@type": "Country",
      "iso3": "ARG",
      "iso2": "AR",
      "name": "Argentina",
      "capital": "Buenos Aires",
      "currency": "ARS",
      "phone": "54",
      "sanctioned": false
    },
    {
      "@id": "/countries/ARM",
      "@type": "Country",
      "iso3": "ARM",
      "iso2": "AM",
      "name": "Armenia",
      "capital": "Yerevan",
      "currency": "AMD",
      "phone": "374",
      "sanctioned": false
    },
    {
      "@id": "/countries/ASM",
      "@type": "Country",
      "iso3": "ASM",
      "iso2": "AS",
      "name": "American Samoa",
      "capital": "Pago Pago",
      "currency": "USD",
      "phone": "+1-684",
      "sanctioned": false
    },
    {
      "@id": "/countries/ATA",
      "@type": "Country",
      "iso3": "ATA",
      "iso2": "AQ",
      "name": "Antarctica",
      "capital": "",
      "currency": "",
      "phone": "",
      "sanctioned": false
    },
    {
      "@id": "/countries/ATF",
      "@type": "Country",
      "iso3": "ATF",
      "iso2": "TF",
      "name": "French Southern Territories",
      "capital": "Port-aux-Francais",
      "currency": "EUR",
      "phone": "",
      "sanctioned": false
    },
    {
      "@id": "/countries/ATG",
      "@type": "Country",
      "iso3": "ATG",
      "iso2": "AG",
      "name": "Antigua and Barbuda",
      "capital": "St. John-s",
      "currency": "XCD",
      "phone": "+1-268",
      "sanctioned": false
    },
    {
      "@id": "/countries/AUS",
      "@type": "Country",
      "iso3": "AUS",
      "iso2": "AU",
      "name": "Australia",
      "capital": "Canberra",
      "currency": "AUD",
      "phone": "61",
      "sanctioned": false
    },
    {
      "@id": "/countries/AUT",
      "@type": "Country",
      "iso3": "AUT",
      "iso2": "AT",
      "name": "Austria",
      "capital": "Vienna",
      "currency": "EUR",
      "phone": "43",
      "sanctioned": false
    },
    {
      "@id": "/countries/AZE",
      "@type": "Country",
      "iso3": "AZE",
      "iso2": "AZ",
      "name": "Azerbaijan",
      "capital": "Baku",
      "currency": "AZN",
      "phone": "994",
      "sanctioned": false
    },
    {
      "@id": "/countries/BDI",
      "@type": "Country",
      "iso3": "BDI",
      "iso2": "BI",
      "name": "Burundi",
      "capital": "Bujumbura",
      "currency": "BIF",
      "phone": "257",
      "sanctioned": false
    },
    {
      "@id": "/countries/BEL",
      "@type": "Country",
      "iso3": "BEL",
      "iso2": "BE",
      "name": "Belgium",
      "capital": "Brussels",
      "currency": "EUR",
      "phone": "32",
      "sanctioned": false
    },
    {
      "@id": "/countries/BEN",
      "@type": "Country",
      "iso3": "BEN",
      "iso2": "BJ",
      "name": "Benin",
      "capital": "Porto-Novo",
      "currency": "XOF",
      "phone": "229",
      "sanctioned": false
    },
    {
      "@id": "/countries/BES",
      "@type": "Country",
      "iso3": "BES",
      "iso2": "BQ",
      "name": "Bonaire, Saint Eustatius and Saba ",
      "capital": "",
      "currency": "USD",
      "phone": "599",
      "sanctioned": false
    },
    {
      "@id": "/countries/BFA",
      "@type": "Country",
      "iso3": "BFA",
      "iso2": "BF",
      "name": "Burkina Faso",
      "capital": "Ouagadougou",
      "currency": "XOF",
      "phone": "226",
      "sanctioned": false
    },
    {
      "@id": "/countries/BGD",
      "@type": "Country",
      "iso3": "BGD",
      "iso2": "BD",
      "name": "Bangladesh",
      "capital": "Dhaka",
      "currency": "BDT",
      "phone": "880",
      "sanctioned": false
    },
    {
      "@id": "/countries/BGR",
      "@type": "Country",
      "iso3": "BGR",
      "iso2": "BG",
      "name": "Bulgaria",
      "capital": "Sofia",
      "currency": "BGN",
      "phone": "359",
      "sanctioned": false
    },
    {
      "@id": "/countries/BHR",
      "@type": "Country",
      "iso3": "BHR",
      "iso2": "BH",
      "name": "Bahrain",
      "capital": "Manama",
      "currency": "BHD",
      "phone": "973",
      "sanctioned": false
    },
    {
      "@id": "/countries/BHS",
      "@type": "Country",
      "iso3": "BHS",
      "iso2": "BS",
      "name": "Bahamas",
      "capital": "Nassau",
      "currency": "BSD",
      "phone": "+1-242",
      "sanctioned": false
    },
    {
      "@id": "/countries/BIH",
      "@type": "Country",
      "iso3": "BIH",
      "iso2": "BA",
      "name": "Bosnia and Herzegovina",
      "capital": "Sarajevo",
      "currency": "BAM",
      "phone": "387",
      "sanctioned": false
    },
    {
      "@id": "/countries/BLM",
      "@type": "Country",
      "iso3": "BLM",
      "iso2": "BL",
      "name": "Saint Barthelemy",
      "capital": "Gustavia",
      "currency": "EUR",
      "phone": "590",
      "sanctioned": false
    },
    {
      "@id": "/countries/BLR",
      "@type": "Country",
      "iso3": "BLR",
      "iso2": "BY",
      "name": "Belarus",
      "capital": "Minsk",
      "currency": "BYR",
      "phone": "375",
      "sanctioned": false
    },
    {
      "@id": "/countries/BLZ",
      "@type": "Country",
      "iso3": "BLZ",
      "iso2": "BZ",
      "name": "Belize",
      "capital": "Belmopan",
      "currency": "BZD",
      "phone": "501",
      "sanctioned": false
    },
    {
      "@id": "/countries/BMU",
      "@type": "Country",
      "iso3": "BMU",
      "iso2": "BM",
      "name": "Bermuda",
      "capital": "Hamilton",
      "currency": "BMD",
      "phone": "+1-441",
      "sanctioned": false
    },
    {
      "@id": "/countries/BOL",
      "@type": "Country",
      "iso3": "BOL",
      "iso2": "BO",
      "name": "Bolivia",
      "capital": "Sucre",
      "currency": "BOB",
      "phone": "591",
      "sanctioned": false
    },
    {
      "@id": "/countries/BRA",
      "@type": "Country",
      "iso3": "BRA",
      "iso2": "BR",
      "name": "Brazil",
      "capital": "Brasilia",
      "currency": "BRL",
      "phone": "55",
      "sanctioned": false
    },
    {
      "@id": "/countries/BRB",
      "@type": "Country",
      "iso3": "BRB",
      "iso2": "BB",
      "name": "Barbados",
      "capital": "Bridgetown",
      "currency": "BBD",
      "phone": "+1-246",
      "sanctioned": false
    },
    {
      "@id": "/countries/BRN",
      "@type": "Country",
      "iso3": "BRN",
      "iso2": "BN",
      "name": "Brunei",
      "capital": "Bandar Seri Begawan",
      "currency": "BND",
      "phone": "673",
      "sanctioned": false
    },
    {
      "@id": "/countries/BTN",
      "@type": "Country",
      "iso3": "BTN",
      "iso2": "BT",
      "name": "Bhutan",
      "capital": "Thimphu",
      "currency": "BTN",
      "phone": "975",
      "sanctioned": false
    },
    {
      "@id": "/countries/BVT",
      "@type": "Country",
      "iso3": "BVT",
      "iso2": "BV",
      "name": "Bouvet Island",
      "capital": "",
      "currency": "NOK",
      "phone": "",
      "sanctioned": false
    },
    {
      "@id": "/countries/BWA",
      "@type": "Country",
      "iso3": "BWA",
      "iso2": "BW",
      "name": "Botswana",
      "capital": "Gaborone",
      "currency": "BWP",
      "phone": "267",
      "sanctioned": false
    },
    {
      "@id": "/countries/CAF",
      "@type": "Country",
      "iso3": "CAF",
      "iso2": "CF",
      "name": "Central African Republic",
      "capital": "Bangui",
      "currency": "XAF",
      "phone": "236",
      "sanctioned": false
    },
    {
      "@id": "/countries/CAN",
      "@type": "Country",
      "iso3": "CAN",
      "iso2": "CA",
      "name": "Canada",
      "capital": "Ottawa",
      "currency": "CAD",
      "phone": "1",
      "sanctioned": false
    },
    {
      "@id": "/countries/CCK",
      "@type": "Country",
      "iso3": "CCK",
      "iso2": "CC",
      "name": "Cocos Islands",
      "capital": "West Island",
      "currency": "AUD",
      "phone": "61",
      "sanctioned": false
    },
    {
      "@id": "/countries/CHE",
      "@type": "Country",
      "iso3": "CHE",
      "iso2": "CH",
      "name": "Switzerland",
      "capital": "Berne",
      "currency": "CHF",
      "phone": "41",
      "sanctioned": false
    },
    {
      "@id": "/countries/CHL",
      "@type": "Country",
      "iso3": "CHL",
      "iso2": "CL",
      "name": "Chile",
      "capital": "Santiago",
      "currency": "CLP",
      "phone": "56",
      "sanctioned": false
    },
    {
      "@id": "/countries/CHN",
      "@type": "Country",
      "iso3": "CHN",
      "iso2": "CN",
      "name": "China",
      "capital": "Beijing",
      "currency": "CNY",
      "phone": "86",
      "sanctioned": false
    },
    {
      "@id": "/countries/CIV",
      "@type": "Country",
      "iso3": "CIV",
      "iso2": "CI",
      "name": "Ivory Coast",
      "capital": "Yamoussoukro",
      "currency": "XOF",
      "phone": "225",
      "sanctioned": false
    },
    {
      "@id": "/countries/CMR",
      "@type": "Country",
      "iso3": "CMR",
      "iso2": "CM",
      "name": "Cameroon",
      "capital": "Yaounde",
      "currency": "XAF",
      "phone": "237",
      "sanctioned": false
    },
    {
      "@id": "/countries/COD",
      "@type": "Country",
      "iso3": "COD",
      "iso2": "CD",
      "name": "Democratic Republic of the Congo",
      "capital": "Kinshasa",
      "currency": "CDF",
      "phone": "243",
      "sanctioned": false
    },
    {
      "@id": "/countries/COG",
      "@type": "Country",
      "iso3": "COG",
      "iso2": "CG",
      "name": "Republic of the Congo",
      "capital": "Brazzaville",
      "currency": "XAF",
      "phone": "242",
      "sanctioned": false
    },
    {
      "@id": "/countries/COK",
      "@type": "Country",
      "iso3": "COK",
      "iso2": "CK",
      "name": "Cook Islands",
      "capital": "Avarua",
      "currency": "NZD",
      "phone": "682",
      "sanctioned": false
    },
    {
      "@id": "/countries/COL",
      "@type": "Country",
      "iso3": "COL",
      "iso2": "CO",
      "name": "Colombia",
      "capital": "Bogota",
      "currency": "COP",
      "phone": "57",
      "sanctioned": false
    },
    {
      "@id": "/countries/COM",
      "@type": "Country",
      "iso3": "COM",
      "iso2": "KM",
      "name": "Comoros",
      "capital": "Moroni",
      "currency": "KMF",
      "phone": "269",
      "sanctioned": false
    },
    {
      "@id": "/countries/CPV",
      "@type": "Country",
      "iso3": "CPV",
      "iso2": "CV",
      "name": "Cape Verde",
      "capital": "Praia",
      "currency": "CVE",
      "phone": "238",
      "sanctioned": false
    },
    {
      "@id": "/countries/CRI",
      "@type": "Country",
      "iso3": "CRI",
      "iso2": "CR",
      "name": "Costa Rica",
      "capital": "San Jose",
      "currency": "CRC",
      "phone": "506",
      "sanctioned": false
    },
    {
      "@id": "/countries/CUB",
      "@type": "Country",
      "iso3": "CUB",
      "iso2": "CU",
      "name": "Cuba",
      "capital": "Havana",
      "currency": "CUP",
      "phone": "53",
      "sanctioned": false
    },
    {
      "@id": "/countries/CUW",
      "@type": "Country",
      "iso3": "CUW",
      "iso2": "CW",
      "name": "Curacao",
      "capital": " Willemstad",
      "currency": "ANG",
      "phone": "599",
      "sanctioned": false
    },
    {
      "@id": "/countries/CXR",
      "@type": "Country",
      "iso3": "CXR",
      "iso2": "CX",
      "name": "Christmas Island",
      "capital": "Flying Fish Cove",
      "currency": "AUD",
      "phone": "61",
      "sanctioned": false
    },
    {
      "@id": "/countries/CYM",
      "@type": "Country",
      "iso3": "CYM",
      "iso2": "KY",
      "name": "Cayman Islands",
      "capital": "George Town",
      "currency": "KYD",
      "phone": "+1-345",
      "sanctioned": false
    },
    {
      "@id": "/countries/CYP",
      "@type": "Country",
      "iso3": "CYP",
      "iso2": "CY",
      "name": "Cyprus",
      "capital": "Nicosia",
      "currency": "EUR",
      "phone": "357",
      "sanctioned": false
    },
    {
      "@id": "/countries/CZE",
      "@type": "Country",
      "iso3": "CZE",
      "iso2": "CZ",
      "name": "Czech Republic",
      "capital": "Prague",
      "currency": "CZK",
      "phone": "420",
      "sanctioned": false
    },
    {
      "@id": "/countries/DEU",
      "@type": "Country",
      "iso3": "DEU",
      "iso2": "DE",
      "name": "Germany",
      "capital": "Berlin",
      "currency": "EUR",
      "phone": "49",
      "sanctioned": false
    },
    {
      "@id": "/countries/DJI",
      "@type": "Country",
      "iso3": "DJI",
      "iso2": "DJ",
      "name": "Djibouti",
      "capital": "Djibouti",
      "currency": "DJF",
      "phone": "253",
      "sanctioned": false
    },
    {
      "@id": "/countries/DMA",
      "@type": "Country",
      "iso3": "DMA",
      "iso2": "DM",
      "name": "Dominica",
      "capital": "Roseau",
      "currency": "XCD",
      "phone": "+1-767",
      "sanctioned": false
    },
    {
      "@id": "/countries/DNK",
      "@type": "Country",
      "iso3": "DNK",
      "iso2": "DK",
      "name": "Denmark",
      "capital": "Copenhagen",
      "currency": "DKK",
      "phone": "45",
      "sanctioned": false
    },
    {
      "@id": "/countries/DOM",
      "@type": "Country",
      "iso3": "DOM",
      "iso2": "DO",
      "name": "Dominican Republic",
      "capital": "Santo Domingo",
      "currency": "DOP",
      "phone": "+1-809 and 1-829",
      "sanctioned": false
    },
    {
      "@id": "/countries/DZA",
      "@type": "Country",
      "iso3": "DZA",
      "iso2": "DZ",
      "name": "Algeria",
      "capital": "Algiers",
      "currency": "DZD",
      "phone": "213",
      "sanctioned": false
    },
    {
      "@id": "/countries/ECU",
      "@type": "Country",
      "iso3": "ECU",
      "iso2": "EC",
      "name": "Ecuador",
      "capital": "Quito",
      "currency": "USD",
      "phone": "593",
      "sanctioned": false
    },
    {
      "@id": "/countries/EGY",
      "@type": "Country",
      "iso3": "EGY",
      "iso2": "EG",
      "name": "Egypt",
      "capital": "Cairo",
      "currency": "EGP",
      "phone": "20",
      "sanctioned": false
    },
    {
      "@id": "/countries/ERI",
      "@type": "Country",
      "iso3": "ERI",
      "iso2": "ER",
      "name": "Eritrea",
      "capital": "Asmara",
      "currency": "ERN",
      "phone": "291",
      "sanctioned": false
    },
    {
      "@id": "/countries/ESH",
      "@type": "Country",
      "iso3": "ESH",
      "iso2": "EH",
      "name": "Western Sahara",
      "capital": "El-Aaiun",
      "currency": "MAD",
      "phone": "212",
      "sanctioned": false
    },
    {
      "@id": "/countries/ESP",
      "@type": "Country",
      "iso3": "ESP",
      "iso2": "ES",
      "name": "Spain",
      "capital": "Madrid",
      "currency": "EUR",
      "phone": "34",
      "sanctioned": false
    },
    {
      "@id": "/countries/EST",
      "@type": "Country",
      "iso3": "EST",
      "iso2": "EE",
      "name": "Estonia",
      "capital": "Tallinn",
      "currency": "EUR",
      "phone": "372",
      "sanctioned": false
    },
    {
      "@id": "/countries/ETH",
      "@type": "Country",
      "iso3": "ETH",
      "iso2": "ET",
      "name": "Ethiopia",
      "capital": "Addis Ababa",
      "currency": "ETB",
      "phone": "251",
      "sanctioned": false
    },
    {
      "@id": "/countries/FIN",
      "@type": "Country",
      "iso3": "FIN",
      "iso2": "FI",
      "name": "Finland",
      "capital": "Helsinki",
      "currency": "EUR",
      "phone": "358",
      "sanctioned": false
    },
    {
      "@id": "/countries/FJI",
      "@type": "Country",
      "iso3": "FJI",
      "iso2": "FJ",
      "name": "Fiji",
      "capital": "Suva",
      "currency": "FJD",
      "phone": "679",
      "sanctioned": false
    },
    {
      "@id": "/countries/FLK",
      "@type": "Country",
      "iso3": "FLK",
      "iso2": "FK",
      "name": "Falkland Islands",
      "capital": "Stanley",
      "currency": "FKP",
      "phone": "500",
      "sanctioned": false
    },
    {
      "@id": "/countries/FRA",
      "@type": "Country",
      "iso3": "FRA",
      "iso2": "FR",
      "name": "France",
      "capital": "Paris",
      "currency": "EUR",
      "phone": "33",
      "sanctioned": false
    },
    {
      "@id": "/countries/FRO",
      "@type": "Country",
      "iso3": "FRO",
      "iso2": "FO",
      "name": "Faroe Islands",
      "capital": "Torshavn",
      "currency": "DKK",
      "phone": "298",
      "sanctioned": false
    },
    {
      "@id": "/countries/FSM",
      "@type": "Country",
      "iso3": "FSM",
      "iso2": "FM",
      "name": "Micronesia",
      "capital": "Palikir",
      "currency": "USD",
      "phone": "691",
      "sanctioned": false
    },
    {
      "@id": "/countries/GAB",
      "@type": "Country",
      "iso3": "GAB",
      "iso2": "GA",
      "name": "Gabon",
      "capital": "Libreville",
      "currency": "XAF",
      "phone": "241",
      "sanctioned": false
    },
    {
      "@id": "/countries/GBR",
      "@type": "Country",
      "iso3": "GBR",
      "iso2": "GB",
      "name": "United Kingdom",
      "capital": "London",
      "currency": "GBP",
      "phone": "44",
      "sanctioned": false
    },
    {
      "@id": "/countries/GEO",
      "@type": "Country",
      "iso3": "GEO",
      "iso2": "GE",
      "name": "Georgia",
      "capital": "Tbilisi",
      "currency": "GEL",
      "phone": "995",
      "sanctioned": false
    },
    {
      "@id": "/countries/GGY",
      "@type": "Country",
      "iso3": "GGY",
      "iso2": "GG",
      "name": "Guernsey",
      "capital": "St Peter Port",
      "currency": "GBP",
      "phone": "+44-1481",
      "sanctioned": false
    },
    {
      "@id": "/countries/GHA",
      "@type": "Country",
      "iso3": "GHA",
      "iso2": "GH",
      "name": "Ghana",
      "capital": "Accra",
      "currency": "GHS",
      "phone": "233",
      "sanctioned": false
    },
    {
      "@id": "/countries/GIB",
      "@type": "Country",
      "iso3": "GIB",
      "iso2": "GI",
      "name": "Gibraltar",
      "capital": "Gibraltar",
      "currency": "GIP",
      "phone": "350",
      "sanctioned": false
    },
    {
      "@id": "/countries/GIN",
      "@type": "Country",
      "iso3": "GIN",
      "iso2": "GN",
      "name": "Guinea",
      "capital": "Conakry",
      "currency": "GNF",
      "phone": "224",
      "sanctioned": false
    },
    {
      "@id": "/countries/GLP",
      "@type": "Country",
      "iso3": "GLP",
      "iso2": "GP",
      "name": "Guadeloupe",
      "capital": "Basse-Terre",
      "currency": "EUR",
      "phone": "590",
      "sanctioned": false
    },
    {
      "@id": "/countries/GMB",
      "@type": "Country",
      "iso3": "GMB",
      "iso2": "GM",
      "name": "Gambia",
      "capital": "Banjul",
      "currency": "GMD",
      "phone": "220",
      "sanctioned": false
    },
    {
      "@id": "/countries/GNB",
      "@type": "Country",
      "iso3": "GNB",
      "iso2": "GW",
      "name": "Guinea-Bissau",
      "capital": "Bissau",
      "currency": "XOF",
      "phone": "245",
      "sanctioned": false
    },
    {
      "@id": "/countries/GNQ",
      "@type": "Country",
      "iso3": "GNQ",
      "iso2": "GQ",
      "name": "Equatorial Guinea",
      "capital": "Malabo",
      "currency": "XAF",
      "phone": "240",
      "sanctioned": false
    },
    {
      "@id": "/countries/GRC",
      "@type": "Country",
      "iso3": "GRC",
      "iso2": "GR",
      "name": "Greece",
      "capital": "Athens",
      "currency": "EUR",
      "phone": "30",
      "sanctioned": false
    },
    {
      "@id": "/countries/GRD",
      "@type": "Country",
      "iso3": "GRD",
      "iso2": "GD",
      "name": "Grenada",
      "capital": "St. George-s",
      "currency": "XCD",
      "phone": "+1-473",
      "sanctioned": false
    },
    {
      "@id": "/countries/GRL",
      "@type": "Country",
      "iso3": "GRL",
      "iso2": "GL",
      "name": "Greenland",
      "capital": "Nuuk",
      "currency": "DKK",
      "phone": "299",
      "sanctioned": false
    },
    {
      "@id": "/countries/GTM",
      "@type": "Country",
      "iso3": "GTM",
      "iso2": "GT",
      "name": "Guatemala",
      "capital": "Guatemala City",
      "currency": "GTQ",
      "phone": "502",
      "sanctioned": false
    },
    {
      "@id": "/countries/GUF",
      "@type": "Country",
      "iso3": "GUF",
      "iso2": "GF",
      "name": "French Guiana",
      "capital": "Cayenne",
      "currency": "EUR",
      "phone": "594",
      "sanctioned": false
    },
    {
      "@id": "/countries/GUM",
      "@type": "Country",
      "iso3": "GUM",
      "iso2": "GU",
      "name": "Guam",
      "capital": "Hagatna",
      "currency": "USD",
      "phone": "+1-671",
      "sanctioned": false
    },
    {
      "@id": "/countries/GUY",
      "@type": "Country",
      "iso3": "GUY",
      "iso2": "GY",
      "name": "Guyana",
      "capital": "Georgetown",
      "currency": "GYD",
      "phone": "592",
      "sanctioned": false
    },
    {
      "@id": "/countries/HKG",
      "@type": "Country",
      "iso3": "HKG",
      "iso2": "HK",
      "name": "Hong Kong",
      "capital": "Hong Kong",
      "currency": "HKD",
      "phone": "852",
      "sanctioned": false
    },
    {
      "@id": "/countries/HMD",
      "@type": "Country",
      "iso3": "HMD",
      "iso2": "HM",
      "name": "Heard Island and McDonald Islands",
      "capital": "",
      "currency": "AUD",
      "phone": " ",
      "sanctioned": false
    },
    {
      "@id": "/countries/HND",
      "@type": "Country",
      "iso3": "HND",
      "iso2": "HN",
      "name": "Honduras",
      "capital": "Tegucigalpa",
      "currency": "HNL",
      "phone": "504",
      "sanctioned": false
    },
    {
      "@id": "/countries/HRV",
      "@type": "Country",
      "iso3": "HRV",
      "iso2": "HR",
      "name": "Croatia",
      "capital": "Zagreb",
      "currency": "HRK",
      "phone": "385",
      "sanctioned": false
    },
    {
      "@id": "/countries/HTI",
      "@type": "Country",
      "iso3": "HTI",
      "iso2": "HT",
      "name": "Haiti",
      "capital": "Port-au-Prince",
      "currency": "HTG",
      "phone": "509",
      "sanctioned": false
    },
    {
      "@id": "/countries/HUN",
      "@type": "Country",
      "iso3": "HUN",
      "iso2": "HU",
      "name": "Hungary",
      "capital": "Budapest",
      "currency": "HUF",
      "phone": "36",
      "sanctioned": false
    },
    {
      "@id": "/countries/IDN",
      "@type": "Country",
      "iso3": "IDN",
      "iso2": "ID",
      "name": "Indonesia",
      "capital": "Jakarta",
      "currency": "IDR",
      "phone": "62",
      "sanctioned": false
    },
    {
      "@id": "/countries/IMN",
      "@type": "Country",
      "iso3": "IMN",
      "iso2": "IM",
      "name": "Isle of Man",
      "capital": "Douglas, Isle of Man",
      "currency": "GBP",
      "phone": "+44-1624",
      "sanctioned": false
    },
    {
      "@id": "/countries/IND",
      "@type": "Country",
      "iso3": "IND",
      "iso2": "IN",
      "name": "India",
      "capital": "New Delhi",
      "currency": "INR",
      "phone": "91",
      "sanctioned": false
    },
    {
      "@id": "/countries/IOT",
      "@type": "Country",
      "iso3": "IOT",
      "iso2": "IO",
      "name": "British Indian Ocean Territory",
      "capital": "Diego Garcia",
      "currency": "USD",
      "phone": "246",
      "sanctioned": false
    },
    {
      "@id": "/countries/IRL",
      "@type": "Country",
      "iso3": "IRL",
      "iso2": "IE",
      "name": "Ireland",
      "capital": "Dublin",
      "currency": "EUR",
      "phone": "353",
      "sanctioned": false
    },
    {
      "@id": "/countries/IRN",
      "@type": "Country",
      "iso3": "IRN",
      "iso2": "IR",
      "name": "Iran",
      "capital": "Tehran",
      "currency": "IRR",
      "phone": "98",
      "sanctioned": false
    },
    {
      "@id": "/countries/IRQ",
      "@type": "Country",
      "iso3": "IRQ",
      "iso2": "IQ",
      "name": "Iraq",
      "capital": "Baghdad",
      "currency": "IQD",
      "phone": "964",
      "sanctioned": false
    },
    {
      "@id": "/countries/ISL",
      "@type": "Country",
      "iso3": "ISL",
      "iso2": "IS",
      "name": "Iceland",
      "capital": "Reykjavik",
      "currency": "ISK",
      "phone": "354",
      "sanctioned": false
    },
    {
      "@id": "/countries/ISR",
      "@type": "Country",
      "iso3": "ISR",
      "iso2": "IL",
      "name": "Israel",
      "capital": "Jerusalem",
      "currency": "ILS",
      "phone": "972",
      "sanctioned": false
    },
    {
      "@id": "/countries/ITA",
      "@type": "Country",
      "iso3": "ITA",
      "iso2": "IT",
      "name": "Italy",
      "capital": "Rome",
      "currency": "EUR",
      "phone": "39",
      "sanctioned": false
    },
    {
      "@id": "/countries/JAM",
      "@type": "Country",
      "iso3": "JAM",
      "iso2": "JM",
      "name": "Jamaica",
      "capital": "Kingston",
      "currency": "JMD",
      "phone": "+1-876",
      "sanctioned": false
    },
    {
      "@id": "/countries/JEY",
      "@type": "Country",
      "iso3": "JEY",
      "iso2": "JE",
      "name": "Jersey",
      "capital": "Saint Helier",
      "currency": "GBP",
      "phone": "+44-1534",
      "sanctioned": false
    },
    {
      "@id": "/countries/JOR",
      "@type": "Country",
      "iso3": "JOR",
      "iso2": "JO",
      "name": "Jordan",
      "capital": "Amman",
      "currency": "JOD",
      "phone": "962",
      "sanctioned": false
    },
    {
      "@id": "/countries/JPN",
      "@type": "Country",
      "iso3": "JPN",
      "iso2": "JP",
      "name": "Japan",
      "capital": "Tokyo",
      "currency": "JPY",
      "phone": "81",
      "sanctioned": false
    },
    {
      "@id": "/countries/KAZ",
      "@type": "Country",
      "iso3": "KAZ",
      "iso2": "KZ",
      "name": "Kazakhstan",
      "capital": "Astana",
      "currency": "KZT",
      "phone": "7",
      "sanctioned": false
    },
    {
      "@id": "/countries/KEN",
      "@type": "Country",
      "iso3": "KEN",
      "iso2": "KE",
      "name": "Kenya",
      "capital": "Nairobi",
      "currency": "KES",
      "phone": "254",
      "sanctioned": false
    },
    {
      "@id": "/countries/KGZ",
      "@type": "Country",
      "iso3": "KGZ",
      "iso2": "KG",
      "name": "Kyrgyzstan",
      "capital": "Bishkek",
      "currency": "KGS",
      "phone": "996",
      "sanctioned": false
    },
    {
      "@id": "/countries/KHM",
      "@type": "Country",
      "iso3": "KHM",
      "iso2": "KH",
      "name": "Cambodia",
      "capital": "Phnom Penh",
      "currency": "KHR",
      "phone": "855",
      "sanctioned": false
    },
    {
      "@id": "/countries/KIR",
      "@type": "Country",
      "iso3": "KIR",
      "iso2": "KI",
      "name": "Kiribati",
      "capital": "Tarawa",
      "currency": "AUD",
      "phone": "686",
      "sanctioned": false
    },
    {
      "@id": "/countries/KNA",
      "@type": "Country",
      "iso3": "KNA",
      "iso2": "KN",
      "name": "Saint Kitts and Nevis",
      "capital": "Basseterre",
      "currency": "XCD",
      "phone": "+1-869",
      "sanctioned": false
    },
    {
      "@id": "/countries/KOR",
      "@type": "Country",
      "iso3": "KOR",
      "iso2": "KR",
      "name": "South Korea",
      "capital": "Seoul",
      "currency": "KRW",
      "phone": "82",
      "sanctioned": false
    },
    {
      "@id": "/countries/KWT",
      "@type": "Country",
      "iso3": "KWT",
      "iso2": "KW",
      "name": "Kuwait",
      "capital": "Kuwait City",
      "currency": "KWD",
      "phone": "965",
      "sanctioned": false
    },
    {
      "@id": "/countries/LAO",
      "@type": "Country",
      "iso3": "LAO",
      "iso2": "LA",
      "name": "Laos",
      "capital": "Vientiane",
      "currency": "LAK",
      "phone": "856",
      "sanctioned": false
    },
    {
      "@id": "/countries/LBN",
      "@type": "Country",
      "iso3": "LBN",
      "iso2": "LB",
      "name": "Lebanon",
      "capital": "Beirut",
      "currency": "LBP",
      "phone": "961",
      "sanctioned": false
    },
    {
      "@id": "/countries/LBR",
      "@type": "Country",
      "iso3": "LBR",
      "iso2": "LR",
      "name": "Liberia",
      "capital": "Monrovia",
      "currency": "LRD",
      "phone": "231",
      "sanctioned": false
    },
    {
      "@id": "/countries/LBY",
      "@type": "Country",
      "iso3": "LBY",
      "iso2": "LY",
      "name": "Libya",
      "capital": "Tripolis",
      "currency": "LYD",
      "phone": "218",
      "sanctioned": false
    },
    {
      "@id": "/countries/LCA",
      "@type": "Country",
      "iso3": "LCA",
      "iso2": "LC",
      "name": "Saint Lucia",
      "capital": "Castries",
      "currency": "XCD",
      "phone": "+1-758",
      "sanctioned": false
    },
    {
      "@id": "/countries/LIE",
      "@type": "Country",
      "iso3": "LIE",
      "iso2": "LI",
      "name": "Liechtenstein",
      "capital": "Vaduz",
      "currency": "CHF",
      "phone": "423",
      "sanctioned": false
    },
    {
      "@id": "/countries/LKA",
      "@type": "Country",
      "iso3": "LKA",
      "iso2": "LK",
      "name": "Sri Lanka",
      "capital": "Colombo",
      "currency": "LKR",
      "phone": "94",
      "sanctioned": false
    },
    {
      "@id": "/countries/LSO",
      "@type": "Country",
      "iso3": "LSO",
      "iso2": "LS",
      "name": "Lesotho",
      "capital": "Maseru",
      "currency": "LSL",
      "phone": "266",
      "sanctioned": false
    },
    {
      "@id": "/countries/LTU",
      "@type": "Country",
      "iso3": "LTU",
      "iso2": "LT",
      "name": "Lithuania",
      "capital": "Vilnius",
      "currency": "LTL",
      "phone": "370",
      "sanctioned": false
    },
    {
      "@id": "/countries/LUX",
      "@type": "Country",
      "iso3": "LUX",
      "iso2": "LU",
      "name": "Luxembourg",
      "capital": "Luxembourg",
      "currency": "EUR",
      "phone": "352",
      "sanctioned": false
    },
    {
      "@id": "/countries/LVA",
      "@type": "Country",
      "iso3": "LVA",
      "iso2": "LV",
      "name": "Latvia",
      "capital": "Riga",
      "currency": "EUR",
      "phone": "371",
      "sanctioned": false
    },
    {
      "@id": "/countries/MAC",
      "@type": "Country",
      "iso3": "MAC",
      "iso2": "MO",
      "name": "Macao",
      "capital": "Macao",
      "currency": "MOP",
      "phone": "853",
      "sanctioned": false
    },
    {
      "@id": "/countries/MAF",
      "@type": "Country",
      "iso3": "MAF",
      "iso2": "MF",
      "name": "Saint Martin",
      "capital": "Marigot",
      "currency": "EUR",
      "phone": "590",
      "sanctioned": false
    },
    {
      "@id": "/countries/MAR",
      "@type": "Country",
      "iso3": "MAR",
      "iso2": "MA",
      "name": "Morocco",
      "capital": "Rabat",
      "currency": "MAD",
      "phone": "212",
      "sanctioned": false
    },
    {
      "@id": "/countries/MCO",
      "@type": "Country",
      "iso3": "MCO",
      "iso2": "MC",
      "name": "Monaco",
      "capital": "Monaco",
      "currency": "EUR",
      "phone": "377",
      "sanctioned": false
    },
    {
      "@id": "/countries/MDA",
      "@type": "Country",
      "iso3": "MDA",
      "iso2": "MD",
      "name": "Moldova",
      "capital": "Chisinau",
      "currency": "MDL",
      "phone": "373",
      "sanctioned": false
    },
    {
      "@id": "/countries/MDG",
      "@type": "Country",
      "iso3": "MDG",
      "iso2": "MG",
      "name": "Madagascar",
      "capital": "Antananarivo",
      "currency": "MGA",
      "phone": "261",
      "sanctioned": false
    },
    {
      "@id": "/countries/MDV",
      "@type": "Country",
      "iso3": "MDV",
      "iso2": "MV",
      "name": "Maldives",
      "capital": "Male",
      "currency": "MVR",
      "phone": "960",
      "sanctioned": false
    },
    {
      "@id": "/countries/MEX",
      "@type": "Country",
      "iso3": "MEX",
      "iso2": "MX",
      "name": "Mexico",
      "capital": "Mexico City",
      "currency": "MXN",
      "phone": "52",
      "sanctioned": false
    },
    {
      "@id": "/countries/MHL",
      "@type": "Country",
      "iso3": "MHL",
      "iso2": "MH",
      "name": "Marshall Islands",
      "capital": "Majuro",
      "currency": "USD",
      "phone": "692",
      "sanctioned": false
    },
    {
      "@id": "/countries/MKD",
      "@type": "Country",
      "iso3": "MKD",
      "iso2": "MK",
      "name": "Macedonia",
      "capital": "Skopje",
      "currency": "MKD",
      "phone": "389",
      "sanctioned": false
    },
    {
      "@id": "/countries/MLI",
      "@type": "Country",
      "iso3": "MLI",
      "iso2": "ML",
      "name": "Mali",
      "capital": "Bamako",
      "currency": "XOF",
      "phone": "223",
      "sanctioned": false
    },
    {
      "@id": "/countries/MLT",
      "@type": "Country",
      "iso3": "MLT",
      "iso2": "MT",
      "name": "Malta",
      "capital": "Valletta",
      "currency": "EUR",
      "phone": "356",
      "sanctioned": false
    },
    {
      "@id": "/countries/MMR",
      "@type": "Country",
      "iso3": "MMR",
      "iso2": "MM",
      "name": "Myanmar",
      "capital": "Nay Pyi Taw",
      "currency": "MMK",
      "phone": "95",
      "sanctioned": false
    },
    {
      "@id": "/countries/MNE",
      "@type": "Country",
      "iso3": "MNE",
      "iso2": "ME",
      "name": "Montenegro",
      "capital": "Podgorica",
      "currency": "EUR",
      "phone": "382",
      "sanctioned": false
    },
    {
      "@id": "/countries/MNG",
      "@type": "Country",
      "iso3": "MNG",
      "iso2": "MN",
      "name": "Mongolia",
      "capital": "Ulan Bator",
      "currency": "MNT",
      "phone": "976",
      "sanctioned": false
    },
     {
      "@id": "/countries/MNP",
      "@type": "Country",
      "iso3": "MNP",
      "iso2": "MP",
      "name": "Northern Mariana Islands",
      "capital": "Saipan",
      "currency": "USD",
      "phone": "+1-670",
      "sanctioned": false
    },
    {
      "@id": "/countries/MOZ",
      "@type": "Country",
      "iso3": "MOZ",
      "iso2": "MZ",
      "name": "Mozambique",
      "capital": "Maputo",
      "currency": "MZN",
      "phone": "258",
      "sanctioned": false
    },
    {
      "@id": "/countries/MRT",
      "@type": "Country",
      "iso3": "MRT",
      "iso2": "MR",
      "name": "Mauritania",
      "capital": "Nouakchott",
      "currency": "MRO",
      "phone": "222",
      "sanctioned": false
    },
    {
      "@id": "/countries/MSR",
      "@type": "Country",
      "iso3": "MSR",
      "iso2": "MS",
      "name": "Montserrat",
      "capital": "Plymouth",
      "currency": "XCD",
      "phone": "+1-664",
      "sanctioned": false
    },
    {
      "@id": "/countries/MTQ",
      "@type": "Country",
      "iso3": "MTQ",
      "iso2": "MQ",
      "name": "Martinique",
      "capital": "Fort-de-France",
      "currency": "EUR",
      "phone": "596",
      "sanctioned": false
    },
    {
      "@id": "/countries/MUS",
      "@type": "Country",
      "iso3": "MUS",
      "iso2": "MU",
      "name": "Mauritius",
      "capital": "Port Louis",
      "currency": "MUR",
      "phone": "230",
      "sanctioned": false
    },
    {
      "@id": "/countries/MWI",
      "@type": "Country",
      "iso3": "MWI",
      "iso2": "MW",
      "name": "Malawi",
      "capital": "Lilongwe",
      "currency": "MWK",
      "phone": "265",
      "sanctioned": false
    },
    {
      "@id": "/countries/MYS",
      "@type": "Country",
      "iso3": "MYS",
      "iso2": "MY",
      "name": "Malaysia",
      "capital": "Kuala Lumpur",
      "currency": "MYR",
      "phone": "60",
      "sanctioned": false
    },
    {
      "@id": "/countries/MYT",
      "@type": "Country",
      "iso3": "MYT",
      "iso2": "YT",
      "name": "Mayotte",
      "capital": "Mamoudzou",
      "currency": "EUR",
      "phone": "262",
      "sanctioned": false
    },
    {
      "@id": "/countries/NAM",
      "@type": "Country",
      "iso3": "NAM",
      "iso2": "NA",
      "name": "Namibia",
      "capital": "Windhoek",
      "currency": "NAD",
      "phone": "264",
      "sanctioned": false
    },
    {
      "@id": "/countries/NCL",
      "@type": "Country",
      "iso3": "NCL",
      "iso2": "NC",
      "name": "New Caledonia",
      "capital": "Noumea",
      "currency": "XPF",
      "phone": "687",
      "sanctioned": false
    },
    {
      "@id": "/countries/NER",
      "@type": "Country",
      "iso3": "NER",
      "iso2": "NE",
      "name": "Niger",
      "capital": "Niamey",
      "currency": "XOF",
      "phone": "227",
      "sanctioned": false
    },
    {
      "@id": "/countries/NFK",
      "@type": "Country",
      "iso3": "NFK",
      "iso2": "NF",
      "name": "Norfolk Island",
      "capital": "Kingston",
      "currency": "AUD",
      "phone": "672",
      "sanctioned": false
    },
    {
      "@id": "/countries/NGA",
      "@type": "Country",
      "iso3": "NGA",
      "iso2": "NG",
      "name": "Nigeria",
      "capital": "Abuja",
      "currency": "NGN",
      "phone": "234",
      "sanctioned": false
    },
    {
      "@id": "/countries/NIC",
      "@type": "Country",
      "iso3": "NIC",
      "iso2": "NI",
      "name": "Nicaragua",
      "capital": "Managua",
      "currency": "NIO",
      "phone": "505",
      "sanctioned": false
    },
    {
      "@id": "/countries/NIU",
      "@type": "Country",
      "iso3": "NIU",
      "iso2": "NU",
      "name": "Niue",
      "capital": "Alofi",
      "currency": "NZD",
      "phone": "683",
      "sanctioned": false
    },
    {
      "@id": "/countries/NLD",
      "@type": "Country",
      "iso3": "NLD",
      "iso2": "NL",
      "name": "Netherlands",
      "capital": "Amsterdam",
      "currency": "EUR",
      "phone": "31",
      "sanctioned": false
    },
    {
      "@id": "/countries/NOR",
      "@type": "Country",
      "iso3": "NOR",
      "iso2": "NO",
      "name": "Norway",
      "capital": "Oslo",
      "currency": "NOK",
      "phone": "47",
      "sanctioned": false
    },
    {
      "@id": "/countries/NPL",
      "@type": "Country",
      "iso3": "NPL",
      "iso2": "NP",
      "name": "Nepal",
      "capital": "Kathmandu",
      "currency": "NPR",
      "phone": "977",
      "sanctioned": false
    },
    {
      "@id": "/countries/NRU",
      "@type": "Country",
      "iso3": "NRU",
      "iso2": "NR",
      "name": "Nauru",
      "capital": "Yaren",
      "currency": "AUD",
      "phone": "674",
      "sanctioned": false
    },
    {
      "@id": "/countries/NZL",
      "@type": "Country",
      "iso3": "NZL",
      "iso2": "NZ",
      "name": "New Zealand",
      "capital": "Wellington",
      "currency": "NZD",
      "phone": "64",
      "sanctioned": false
    },
    {
      "@id": "/countries/OMN",
      "@type": "Country",
      "iso3": "OMN",
      "iso2": "OM",
      "name": "Oman",
      "capital": "Muscat",
      "currency": "OMR",
      "phone": "968",
      "sanctioned": false
    },
    {
      "@id": "/countries/PAK",
      "@type": "Country",
      "iso3": "PAK",
      "iso2": "PK",
      "name": "Pakistan",
      "capital": "Islamabad",
      "currency": "PKR",
      "phone": "92",
      "sanctioned": false
    },
    {
      "@id": "/countries/PAN",
      "@type": "Country",
      "iso3": "PAN",
      "iso2": "PA",
      "name": "Panama",
      "capital": "Panama City",
      "currency": "PAB",
      "phone": "507",
      "sanctioned": false
    },
    {
      "@id": "/countries/PCN",
      "@type": "Country",
      "iso3": "PCN",
      "iso2": "PN",
      "name": "Pitcairn",
      "capital": "Adamstown",
      "currency": "NZD",
      "phone": "870",
      "sanctioned": false
    },
    {
      "@id": "/countries/PER",
      "@type": "Country",
      "iso3": "PER",
      "iso2": "PE",
      "name": "Peru",
      "capital": "Lima",
      "currency": "PEN",
      "phone": "51",
      "sanctioned": false
    },
    {
      "@id": "/countries/PHL",
      "@type": "Country",
      "iso3": "PHL",
      "iso2": "PH",
      "name": "Philippines",
      "capital": "Manila",
      "currency": "PHP",
      "phone": "63",
      "sanctioned": false
    },
    {
      "@id": "/countries/PLW",
      "@type": "Country",
      "iso3": "PLW",
      "iso2": "PW",
      "name": "Palau",
      "capital": "Melekeok",
      "currency": "USD",
      "phone": "680",
      "sanctioned": false
    },
    {
      "@id": "/countries/PNG",
      "@type": "Country",
      "iso3": "PNG",
      "iso2": "PG",
      "name": "Papua New Guinea",
      "capital": "Port Moresby",
      "currency": "PGK",
      "phone": "675",
      "sanctioned": false
    },
    {
      "@id": "/countries/POL",
      "@type": "Country",
      "iso3": "POL",
      "iso2": "PL",
      "name": "Poland",
      "capital": "Warsaw",
      "currency": "PLN",
      "phone": "48",
      "sanctioned": false
    },
    {
      "@id": "/countries/PRI",
      "@type": "Country",
      "iso3": "PRI",
      "iso2": "PR",
      "name": "Puerto Rico",
      "capital": "San Juan",
      "currency": "USD",
      "phone": "+1-787 and 1-939",
      "sanctioned": false
    },
    {
      "@id": "/countries/PRK",
      "@type": "Country",
      "iso3": "PRK",
      "iso2": "KP",
      "name": "North Korea",
      "capital": "Pyongyang",
      "currency": "KPW",
      "phone": "850",
      "sanctioned": false
    },
    {
      "@id": "/countries/PRT",
      "@type": "Country",
      "iso3": "PRT",
      "iso2": "PT",
      "name": "Portugal",
      "capital": "Lisbon",
      "currency": "EUR",
      "phone": "351",
      "sanctioned": false
    },
    {
      "@id": "/countries/PRY",
      "@type": "Country",
      "iso3": "PRY",
      "iso2": "PY",
      "name": "Paraguay",
      "capital": "Asuncion",
      "currency": "PYG",
      "phone": "595",
      "sanctioned": false
    },
    {
      "@id": "/countries/PSE",
      "@type": "Country",
      "iso3": "PSE",
      "iso2": "PS",
      "name": "Palestinian Territory",
      "capital": "East Jerusalem",
      "currency": "ILS",
      "phone": "970",
      "sanctioned": false
    },
    {
      "@id": "/countries/PYF",
      "@type": "Country",
      "iso3": "PYF",
      "iso2": "PF",
      "name": "French Polynesia",
      "capital": "Papeete",
      "currency": "XPF",
      "phone": "689",
      "sanctioned": false
    },
    {
      "@id": "/countries/QAT",
      "@type": "Country",
      "iso3": "QAT",
      "iso2": "QA",
      "name": "Qatar",
      "capital": "Doha",
      "currency": "QAR",
      "phone": "974",
      "sanctioned": false
    },
    {
      "@id": "/countries/REU",
      "@type": "Country",
      "iso3": "REU",
      "iso2": "RE",
      "name": "Reunion",
      "capital": "Saint-Denis",
      "currency": "EUR",
      "phone": "262",
      "sanctioned": false
    },
    {
      "@id": "/countries/ROU",
      "@type": "Country",
      "iso3": "ROU",
      "iso2": "RO",
      "name": "Romania",
      "capital": "Bucharest",
      "currency": "RON",
      "phone": "40",
      "sanctioned": false
    },
    {
      "@id": "/countries/RUS",
      "@type": "Country",
      "iso3": "RUS",
      "iso2": "RU",
      "name": "Russia",
      "capital": "Moscow",
      "currency": "RUB",
      "phone": "7",
      "sanctioned": true
    },
    {
      "@id": "/countries/RWA",
      "@type": "Country",
      "iso3": "RWA",
      "iso2": "RW",
      "name": "Rwanda",
      "capital": "Kigali",
      "currency": "RWF",
      "phone": "250",
      "sanctioned": false
    },
    {
      "@id": "/countries/SAU",
      "@type": "Country",
      "iso3": "SAU",
      "iso2": "SA",
      "name": "Saudi Arabia",
      "capital": "Riyadh",
      "currency": "SAR",
      "phone": "966",
      "sanctioned": false
    },
    {
      "@id": "/countries/SDN",
      "@type": "Country",
      "iso3": "SDN",
      "iso2": "SD",
      "name": "Sudan",
      "capital": "Khartoum",
      "currency": "SDG",
      "phone": "249",
      "sanctioned": false
    },
    {
      "@id": "/countries/SEN",
      "@type": "Country",
      "iso3": "SEN",
      "iso2": "SN",
      "name": "Senegal",
      "capital": "Dakar",
      "currency": "XOF",
      "phone": "221",
      "sanctioned": false
    },
    {
      "@id": "/countries/SGP",
      "@type": "Country",
      "iso3": "SGP",
      "iso2": "SG",
      "name": "Singapore",
      "capital": "Singapur",
      "currency": "SGD",
      "phone": "65",
      "sanctioned": false
    },
    {
      "@id": "/countries/SGS",
      "@type": "Country",
      "iso3": "SGS",
      "iso2": "GS",
      "name": "South Georgia and the South Sandwich Islands",
      "capital": "Grytviken",
      "currency": "GBP",
      "phone": "",
      "sanctioned": false
    },
    {
      "@id": "/countries/SHN",
      "@type": "Country",
      "iso3": "SHN",
      "iso2": "SH",
      "name": "Saint Helena",
      "capital": "Jamestown",
      "currency": "SHP",
      "phone": "290",
      "sanctioned": false
    },
    {
      "@id": "/countries/SJM",
      "@type": "Country",
      "iso3": "SJM",
      "iso2": "SJ",
      "name": "Svalbard and Jan Mayen",
      "capital": "Longyearbyen",
      "currency": "NOK",
      "phone": "47",
      "sanctioned": false
    },
    {
      "@id": "/countries/SLB",
      "@type": "Country",
      "iso3": "SLB",
      "iso2": "SB",
      "name": "Solomon Islands",
      "capital": "Honiara",
      "currency": "SBD",
      "phone": "677",
      "sanctioned": false
    },
    {
      "@id": "/countries/SLE",
      "@type": "Country",
      "iso3": "SLE",
      "iso2": "SL",
      "name": "Sierra Leone",
      "capital": "Freetown",
      "currency": "SLL",
      "phone": "232",
      "sanctioned": false
    },
    {
      "@id": "/countries/SLV",
      "@type": "Country",
      "iso3": "SLV",
      "iso2": "SV",
      "name": "El Salvador",
      "capital": "San Salvador",
      "currency": "USD",
      "phone": "503",
      "sanctioned": false
    },
    {
      "@id": "/countries/SMR",
      "@type": "Country",
      "iso3": "SMR",
      "iso2": "SM",
      "name": "San Marino",
      "capital": "San Marino",
      "currency": "EUR",
      "phone": "378",
      "sanctioned": false
    },
    {
      "@id": "/countries/SOM",
      "@type": "Country",
      "iso3": "SOM",
      "iso2": "SO",
      "name": "Somalia",
      "capital": "Mogadishu",
      "currency": "SOS",
      "phone": "252",
      "sanctioned": false
    },
    {
      "@id": "/countries/SPM",
      "@type": "Country",
      "iso3": "SPM",
      "iso2": "PM",
      "name": "Saint Pierre and Miquelon",
      "capital": "Saint-Pierre",
      "currency": "EUR",
      "phone": "508",
      "sanctioned": false
    },
    {
      "@id": "/countries/SRB",
      "@type": "Country",
      "iso3": "SRB",
      "iso2": "RS",
      "name": "Serbia",
      "capital": "Belgrade",
      "currency": "RSD",
      "phone": "381",
      "sanctioned": false
    },
    {
      "@id": "/countries/SSD",
      "@type": "Country",
      "iso3": "SSD",
      "iso2": "SS",
      "name": "South Sudan",
      "capital": "Juba",
      "currency": "SSP",
      "phone": "211",
      "sanctioned": false
    },
    {
      "@id": "/countries/STP",
      "@type": "Country",
      "iso3": "STP",
      "iso2": "ST",
      "name": "Sao Tome and Principe",
      "capital": "Sao Tome",
      "currency": "STD",
      "phone": "239",
      "sanctioned": false
    },
    {
      "@id": "/countries/SUR",
      "@type": "Country",
      "iso3": "SUR",
      "iso2": "SR",
      "name": "Suriname",
      "capital": "Paramaribo",
      "currency": "SRD",
      "phone": "597",
      "sanctioned": false
    },
    {
      "@id": "/countries/SVK",
      "@type": "Country",
      "iso3": "SVK",
      "iso2": "SK",
      "name": "Slovakia",
      "capital": "Bratislava",
      "currency": "EUR",
      "phone": "421",
      "sanctioned": false
    },
    {
      "@id": "/countries/SVN",
      "@type": "Country",
      "iso3": "SVN",
      "iso2": "SI",
      "name": "Slovenia",
      "capital": "Ljubljana",
      "currency": "EUR",
      "phone": "386",
      "sanctioned": false
    },
    {
      "@id": "/countries/SWE",
      "@type": "Country",
      "iso3": "SWE",
      "iso2": "SE",
      "name": "Sweden",
      "capital": "Stockholm",
      "currency": "SEK",
      "phone": "46",
      "sanctioned": false
    },
    {
      "@id": "/countries/SWZ",
      "@type": "Country",
      "iso3": "SWZ",
      "iso2": "SZ",
      "name": "Swaziland",
      "capital": "Mbabane",
      "currency": "SZL",
      "phone": "268",
      "sanctioned": false
    },
    {
      "@id": "/countries/SXM",
      "@type": "Country",
      "iso3": "SXM",
      "iso2": "SX",
      "name": "Sint Maarten",
      "capital": "Philipsburg",
      "currency": "ANG",
      "phone": "599",
      "sanctioned": false
    },
    {
      "@id": "/countries/SYC",
      "@type": "Country",
      "iso3": "SYC",
      "iso2": "SC",
      "name": "Seychelles",
      "capital": "Victoria",
      "currency": "SCR",
      "phone": "248",
      "sanctioned": false
    },
    {
      "@id": "/countries/SYR",
      "@type": "Country",
      "iso3": "SYR",
      "iso2": "SY",
      "name": "Syria",
      "capital": "Damascus",
      "currency": "SYP",
      "phone": "963",
      "sanctioned": false
    },
    {
      "@id": "/countries/TCA",
      "@type": "Country",
      "iso3": "TCA",
      "iso2": "TC",
      "name": "Turks and Caicos Islands",
      "capital": "Cockburn Town",
      "currency": "USD",
      "phone": "+1-649",
      "sanctioned": false
    },
    {
      "@id": "/countries/TCD",
      "@type": "Country",
      "iso3": "TCD",
      "iso2": "TD",
      "name": "Chad",
      "capital": "N-Djamena",
      "currency": "XAF",
      "phone": "235",
      "sanctioned": false
    },
    {
      "@id": "/countries/TGO",
      "@type": "Country",
      "iso3": "TGO",
      "iso2": "TG",
      "name": "Togo",
      "capital": "Lome",
      "currency": "XOF",
      "phone": "228",
      "sanctioned": false
    },
    {
      "@id": "/countries/THA",
      "@type": "Country",
      "iso3": "THA",
      "iso2": "TH",
      "name": "Thailand",
      "capital": "Bangkok",
      "currency": "THB",
      "phone": "66",
      "sanctioned": false
    },
    {
      "@id": "/countries/TJK",
      "@type": "Country",
      "iso3": "TJK",
      "iso2": "TJ",
      "name": "Tajikistan",
      "capital": "Dushanbe",
      "currency": "TJS",
      "phone": "992",
      "sanctioned": false
    },
    {
      "@id": "/countries/TKL",
      "@type": "Country",
      "iso3": "TKL",
      "iso2": "TK",
      "name": "Tokelau",
      "capital": "",
      "currency": "NZD",
      "phone": "690",
      "sanctioned": false
    },
    {
      "@id": "/countries/TKM",
      "@type": "Country",
      "iso3": "TKM",
      "iso2": "TM",
      "name": "Turkmenistan",
      "capital": "Ashgabat",
      "currency": "TMT",
      "phone": "993",
      "sanctioned": false
    },
    {
      "@id": "/countries/TLS",
      "@type": "Country",
      "iso3": "TLS",
      "iso2": "TL",
      "name": "East Timor",
      "capital": "Dili",
      "currency": "USD",
      "phone": "670",
      "sanctioned": false
    },
    {
      "@id": "/countries/TON",
      "@type": "Country",
      "iso3": "TON",
      "iso2": "TO",
      "name": "Tonga",
      "capital": "Nuku-alofa",
      "currency": "TOP",
      "phone": "676",
      "sanctioned": false
    },
    {
      "@id": "/countries/TTO",
      "@type": "Country",
      "iso3": "TTO",
      "iso2": "TT",
      "name": "Trinidad and Tobago",
      "capital": "Port of Spain",
      "currency": "TTD",
      "phone": "+1-868",
      "sanctioned": false
    },
    {
      "@id": "/countries/TUN",
      "@type": "Country",
      "iso3": "TUN",
      "iso2": "TN",
      "name": "Tunisia",
      "capital": "Tunis",
      "currency": "TND",
      "phone": "216",
      "sanctioned": false
    },
    {
      "@id": "/countries/TUR",
      "@type": "Country",
      "iso3": "TUR",
      "iso2": "TR",
      "name": "Turkey",
      "capital": "Ankara",
      "currency": "TRY",
      "phone": "90",
      "sanctioned": false
    },
    {
      "@id": "/countries/TUV",
      "@type": "Country",
      "iso3": "TUV",
      "iso2": "TV",
      "name": "Tuvalu",
      "capital": "Funafuti",
      "currency": "AUD",
      "phone": "688",
      "sanctioned": false
    },
    {
      "@id": "/countries/TWN",
      "@type": "Country",
      "iso3": "TWN",
      "iso2": "TW",
      "name": "Taiwan",
      "capital": "Taipei",
      "currency": "TWD",
      "phone": "886",
      "sanctioned": false
    },
    {
      "@id": "/countries/TZA",
      "@type": "Country",
      "iso3": "TZA",
      "iso2": "TZ",
      "name": "Tanzania",
      "capital": "Dodoma",
      "currency": "TZS",
      "phone": "255",
      "sanctioned": false
    },
    {
      "@id": "/countries/UGA",
      "@type": "Country",
      "iso3": "UGA",
      "iso2": "UG",
      "name": "Uganda",
      "capital": "Kampala",
      "currency": "UGX",
      "phone": "256",
      "sanctioned": false
    },
    {
      "@id": "/countries/UKR",
      "@type": "Country",
      "iso3": "UKR",
      "iso2": "UA",
      "name": "Ukraine",
      "capital": "Kiev",
      "currency": "UAH",
      "phone": "380",
      "sanctioned": false
    },
    {
      "@id": "/countries/UMI",
      "@type": "Country",
      "iso3": "UMI",
      "iso2": "UM",
      "name": "United States Minor Outlying Islands",
      "capital": "",
      "currency": "USD",
      "phone": "1",
      "sanctioned": false
    },
    {
      "@id": "/countries/URY",
      "@type": "Country",
      "iso3": "URY",
      "iso2": "UY",
      "name": "Uruguay",
      "capital": "Montevideo",
      "currency": "UYU",
      "phone": "598",
      "sanctioned": false
    },
    {
      "@id": "/countries/USA",
      "@type": "Country",
      "iso3": "USA",
      "iso2": "US",
      "name": "United States",
      "capital": "Washington",
      "currency": "USD",
      "phone": "1",
      "sanctioned": false
    },
    {
      "@id": "/countries/UZB",
      "@type": "Country",
      "iso3": "UZB",
      "iso2": "UZ",
      "name": "Uzbekistan",
      "capital": "Tashkent",
      "currency": "UZS",
      "phone": "998",
      "sanctioned": false
    },
    {
      "@id": "/countries/VAT",
      "@type": "Country",
      "iso3": "VAT",
      "iso2": "VA",
      "name": "Vatican",
      "capital": "Vatican City",
      "currency": "EUR",
      "phone": "379",
      "sanctioned": false
    },
    {
      "@id": "/countries/VCT",
      "@type": "Country",
      "iso3": "VCT",
      "iso2": "VC",
      "name": "Saint Vincent and the Grenadines",
      "capital": "Kingstown",
      "currency": "XCD",
      "phone": "+1-784",
      "sanctioned": false
    },
    {
      "@id": "/countries/VEN",
      "@type": "Country",
      "iso3": "VEN",
      "iso2": "VE",
      "name": "Venezuela",
      "capital": "Caracas",
      "currency": "VEF",
      "phone": "58",
      "sanctioned": false
    },
    {
      "@id": "/countries/VGB",
      "@type": "Country",
      "iso3": "VGB",
      "iso2": "VG",
      "name": "British Virgin Islands",
      "capital": "Road Town",
      "currency": "USD",
      "phone": "+1-284",
      "sanctioned": false
    },
    {
      "@id": "/countries/VIR",
      "@type": "Country",
      "iso3": "VIR",
      "iso2": "VI",
      "name": "U.S. Virgin Islands",
      "capital": "Charlotte Amalie",
      "currency": "USD",
      "phone": "+1-340",
      "sanctioned": false
    },
    {
      "@id": "/countries/VNM",
      "@type": "Country",
      "iso3": "VNM",
      "iso2": "VN",
      "name": "Vietnam",
      "capital": "Hanoi",
      "currency": "VND",
      "phone": "84",
      "sanctioned": false
    },
    {
      "@id": "/countries/VUT",
      "@type": "Country",
      "iso3": "VUT",
      "iso2": "VU",
      "name": "Vanuatu",
      "capital": "Port Vila",
      "currency": "VUV",
      "phone": "678",
      "sanctioned": false
    },
    {
      "@id": "/countries/WLF",
      "@type": "Country",
      "iso3": "WLF",
      "iso2": "WF",
      "name": "Wallis and Futuna",
      "capital": "Mata Utu",
      "currency": "XPF",
      "phone": "681",
      "sanctioned": false
    },
    {
      "@id": "/countries/WSM",
      "@type": "Country",
      "iso3": "WSM",
      "iso2": "WS",
      "name": "Samoa",
      "capital": "Apia",
      "currency": "WST",
      "phone": "685",
      "sanctioned": false
    },
    {
      "@id": "/countries/XKX",
      "@type": "Country",
      "iso3": "XKX",
      "iso2": "XK",
      "name": "Kosovo",
      "capital": "Pristina",
      "currency": "EUR",
      "phone": "",
      "sanctioned": false
    },
    {
      "@id": "/countries/XXX",
      "@type": "Country",
      "iso3": "XXX",
      "iso2": "XX",
      "name": "Global",
      "capital": "Global",
      "currency": "???",
      "phone": "???",
      "sanctioned": false
    },
    {
      "@id": "/countries/YEM",
      "@type": "Country",
      "iso3": "YEM",
      "iso2": "YE",
      "name": "Yemen",
      "capital": "Sanaa",
      "currency": "YER",
      "phone": "967",
      "sanctioned": false
    },
    {
      "@id": "/countries/ZAF",
      "@type": "Country",
      "iso3": "ZAF",
      "iso2": "ZA",
      "name": "South Africa",
      "capital": "Pretoria",
      "currency": "ZAR",
      "phone": "27",
      "sanctioned": false
    },
    {
      "@id": "/countries/ZMB",
      "@type": "Country",
      "iso3": "ZMB",
      "iso2": "ZM",
      "name": "Zambia",
      "capital": "Lusaka",
      "currency": "ZMK",
      "phone": "260",
      "sanctioned": false
    },
    {
      "@id": "/countries/ZWE",
      "@type": "Country",
      "iso3": "ZWE",
      "iso2": "ZW",
      "name": "Zimbabwe",
      "capital": "Harare",
      "currency": "ZWL",
      "phone": "263",
      "sanctioned": false
    }
]